module.exports = __webpack_public_path__ + "static/img/three.3152d76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/voice/three.png
// module id = V1mF
// module chunks = 0